/**
 * Очередь роликов плитки мульти-тренда (владелец 23.10: «запуск видео по очереди, если это мультитренд… чтобы любое
 * видео, меняя очередь, запускалось правильно в своей очереди там, где его поставили»): плитка играет ролики версий
 * один за другим, по кругу, в порядке админки (trend_ids; тренд со своим роликом — он первый, как и на плитке).
 * Здесь чистая часть — состав очереди; загрузкой («не грузить все видео сразу») заведует hooks/useTileVideoQueue.
 */
export interface TileVideoEntry {
	/** Участник группы, чей это ролик: по нему подсвечивается его кадр в ряду версий. */
	id: string
	/** Оригинал ролика (со звуком). */
	src: string
	/** Лёгкий сосед `<key>_loop.mp4` — им плитка и играет без звука. */
	loopSrc?: string
	/** Постер ролика: его видно в момент смены ролика, пока следующий не пошёл. */
	poster?: string
}

export interface TileVideoMember {
	id: string
	videoUrl?: string | null
	videoLoopUrl?: string | null
	videoPosterUrl?: string | null
}

/** Состав очереди: ролик самой плитки первым (у папки это ролик первой версии, у тренда со своим содержимым — свой),
 *  дальше версии по порядку. Версия с тем же роликом, что у плитки, второй раз не ставится — но кадр подсвечивается
 *  её. Версии без ролика (фото-тренды) очередь пропускает. Один ролик — очереди нет (длина 1). */
export function buildTileVideoQueue(tile: TileVideoEntry, members: TileVideoMember[]): TileVideoEntry[] {
	const out: TileVideoEntry[] = [tile]
	for (const m of members) {
		if (!m?.id || !m.videoUrl) continue
		const same = out.find((e) => e.src === m.videoUrl)
		if (same) {
			if (same === out[0] && same.id === tile.id && m.id !== tile.id) out[0] = { ...same, id: m.id }
			continue
		}
		out.push({ id: m.id, src: m.videoUrl, loopSrc: m.videoLoopUrl || undefined, poster: m.videoPosterUrl || undefined })
	}
	return out
}

export const EMPTY_TILE_QUEUE: TileVideoEntry[] = []
